<div class="campaigns-page">
	<div class="campaigns-header">
		<h1 class="campaigns-title">Campaigns</h1>
	</div>

	@if (campaignService.loading()) {
		<div class="text-center py-12 text-wb-muted">Loading...</div>
	} @else {
		<div class="campaigns-grid">
			@for (campaign of campaignService.campaigns(); track campaign._id) {
				<div class="campaign-card" (click)="goToCampaign(campaign)">
					<div class="campaign-card-header">
						<i class="pi pi-folder text-lg text-wb-accent"></i>
						<input class="campaign-card-name-input" [value]="campaign.name"
							(click)="$event.stopPropagation()"
							(change)="renameCampaign(campaign, $any($event.target).value)" />
						<button class="campaign-delete" type="button" (click)="deleteCampaign(campaign, $event)" title="Delete campaign">
							<i class="pi pi-trash text-xs"></i>
						</button>
					</div>
					<div class="campaign-card-meta">
						<span class="campaign-card-slug">{{ campaign.slug }}</span>
						<span class="campaign-card-count">{{ campaign.projectCount }} projects</span>
					</div>
				</div>
			}

			<!-- Create new campaign card -->
			<div class="campaign-card campaign-card--create">
				<div class="flex flex-col gap-2 p-3">
					<input
						pInputText
						class="create-input w-full"
						[(ngModel)]="newName"
						placeholder="New campaign name"
						(keydown.enter)="createCampaign()"
					/>
					@if (createError()) {
						<span class="text-[11px] text-wb-danger">{{ createError() }}</span>
					}
					<button class="create-btn" type="button" [disabled]="creating() || !newName.trim()" (click)="createCampaign()">
						@if (creating()) {
							<i class="pi pi-spin pi-spinner text-xs"></i>
						} @else {
							<i class="pi pi-plus text-xs"></i> Create Campaign
						}
					</button>
				</div>
			</div>
		</div>
	}
</div>
